/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Starting_Translation_JobsInputs */



/**
* | output |
* | --- |
* | "Starting {count} translation job(s)... please wait." |
*
* @param {Starting_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const starting_translation_jobs = /** @type {((inputs: Starting_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starting_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Démarrage de ${i?.count} tâche(s) de traduction... veuillez patienter.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Übersetzungsauftrag(e) ${i?.count} werden gestartet... Bitte warten.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Avvio di ${i?.count} lavori di traduzione... attendere.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Запуск задания(-ов) перевода ${i?.count}... пожалуйста, подождите.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Iniciando ${i?.count} trabajo(s) de traducción... por favor espere.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在开始 ${i?.count} 翻译任务……请稍候。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 件の翻訳ジョブを開始しています... お待ちください。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य शुरू हो रहा है... कृपया प्रतीक्षा करें।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Iniciando a(s) tarefa(s) de tradução ${i?.count}... aguarde.`)
	return /** @type {LocalizedString} */ (`Starting ${i?.count} translation job(s)... please wait.`)
});